import React from "react";
import {
  findCurrentTerm,
  findNextAutoDraft,
  isGymOpenToday,
} from "helpers/calendar/calendarTerms";
import { formatDisplayDate, formatShortDate, parseLocalDate } from "helpers/calendar/calendarDates";

const CalendarStatus = ({ config, closedDates, today = new Date() }) => {
  const currentTerm = findCurrentTerm(config.terms, today);
  const isOpen = isGymOpenToday(config, closedDates, today);
  const nextDraft = findNextAutoDraft(config, today);

  return (
    <div className="calendar-status" aria-live="polite">
      <div className="calendar-status__card">
        <p className="calendar-status__label">Today</p>
        <p className="calendar-status__value">
          {isOpen ? (
            <span className="calendar-status__open">Ace is open</span>
          ) : (
            <span className="calendar-status__closed">Ace is closed</span>
          )}
        </p>
      </div>

      {currentTerm && (
        <div className="calendar-status__card">
          <p className="calendar-status__label">Current term</p>
          <p className="calendar-status__value">{currentTerm.name}</p>
          <p className="calendar-status__detail">
            {formatShortDate(parseLocalDate(currentTerm.startDate))} –{" "}
            {formatShortDate(parseLocalDate(currentTerm.endDate))}
          </p>
        </div>
      )}

      {nextDraft && (
        <div className="calendar-status__card calendar-status__card--highlight">
          <p className="calendar-status__label">Next fee auto-draft</p>
          <p className="calendar-status__value">
            {formatDisplayDate(nextDraft.date)}
          </p>
          <p className="calendar-status__detail">{nextDraft.term.name}</p>
        </div>
      )}
    </div>
  );
};

export default CalendarStatus;
